/*
         * @ngdoc function
         * @name ePay.Model:Session_IOTPModel
         * @description
         * Model
         */

export class Session_IOTPModel {
  iotpTransId: string | null | undefined;
  processState: string | null | undefined;
  statusDescription: string | null | undefined;
  paymentDate: string | null | undefined;

  constructor(
    iotpTransId?: string,
    processState?: string,
    statusDescription?: string,
    paymentDate?: string
  ) {
    this.iotpTransId = iotpTransId || null;
    this.processState = processState || null;
    this.statusDescription = statusDescription || null;
    this.paymentDate = paymentDate || null;
  }
}
